/* Endpreis im Warenkorb-Button (Handoff PDP-Kaufspalte §9).
   Hängt nur am bubbelnden `change` von input[name="id"], das Pinnacles
   variant-selects bei jedem Variantenwechsel feuert. Der Preis liegt in einem
   eigenen Span neben .single-add-to-cart-button--text — toggleAddButton()
   überschreibt nur den Text-Span und lässt diesen hier stehen. */
(function () {
  'use strict';

  var prices;

  function load() {
    if (prices !== undefined) return prices;
    prices = null;
    document.querySelectorAll('script[type="application/json"][data-satc-prices]').forEach(function (el) {
      try {
        Object.assign((prices = prices || {}), JSON.parse(el.textContent));
      } catch (e) {
        /* Unlesbares JSON darf den Preis nicht wegräumen — siehe update() */
      }
    });
    return prices;
  }

  function update(variantId) {
    var map = load();
    if (!map) return; /* keine Daten: Label so lassen, wie Liquid es gerendert hat */
    var price = map[variantId];
    document.querySelectorAll('[data-satc-price]').forEach(function (el) {
      el.textContent = price ? '· ' + price : '';
      el.classList.toggle('satc-price-empty', !price);
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.tagName !== 'INPUT' || target.name !== 'id') return;
    if (target.value) update(target.value);
  });
})();
